import { lazy, Suspense } from 'react';

export default (loadFunc, fallbackComponent = null) => {
  const LazyComponent = lazy(loadFunc);
  const WithSuspense = (props) => (
    <Suspense fallback={fallbackComponent}>
      <LazyComponent {...props} />
    </Suspense>
  );

  WithSuspense.displayName = 'withSuspense';

  return WithSuspense;
};
